export type ThemeMode = "light" | "dark" | "custom";
export type WidgetPosition =
  | "bottom-right"
  | "bottom-left"
  | "top-right"
  | "top-left";

export type WidgetTab = "conversations" | "faqs" | "news";

export interface ChatWidgetConfig {
  apiEndpoint: string;
  apiKey: string;
  theme: ThemeMode;
  position: WidgetPosition;
  primaryColor: string;
  bgColor: string;
  textColor: string;
  borderRadius: string;
  fontFamily: string;
  width: string;
  height: string;
  zIndex: string;
  title: string;
  placeholder: string;
  greetingMessage: string;
  userId: string;
  userEmail: string;
  sessionId: string;
}

export interface WidgetMessage {
  id: string;
  type: "user" | "agent";
  content: string;
  timestamp: Date;
  suggestionChips?: string[];
  isStreaming?: boolean;
}

export const DEFAULT_CONFIG: ChatWidgetConfig = {
  apiEndpoint: "",
  apiKey: "",
  theme: "light",
  position: "bottom-right",
  primaryColor: "#dc2626",
  bgColor: "#ffffff",
  textColor: "#171717",
  borderRadius: "16px",
  fontFamily:
    'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  width: "400px",
  height: "600px",
  zIndex: "9999",
  title: "Airo's AI Assistant",
  placeholder: "Type your message...",
  greetingMessage:
    "Hi, welcome! I am Ana, the AI assistant of [Airolabs.ai](https://airolabs.ai). How can I help you today?",
  userId: "",
  userEmail: "",
  sessionId: "",
};

export const ATTR_MAP: Record<string, keyof ChatWidgetConfig> = {
  "api-endpoint": "apiEndpoint",
  "api-key": "apiKey",
  theme: "theme",
  position: "position",
  "primary-color": "primaryColor",
  "bg-color": "bgColor",
  "text-color": "textColor",
  "border-radius": "borderRadius",
  "font-family": "fontFamily",
  width: "width",
  height: "height",
  "z-index": "zIndex",
  // Prefer header-title — bare `title` is an HTML global attr and shows as a native tooltip
  "header-title": "title",
  title: "title",
  placeholder: "placeholder",
  "greeting-message": "greetingMessage",
  "user-id": "userId",
  "user-email": "userEmail",
  "session-id": "sessionId",
};

export const OBSERVED_ATTRIBUTES = Object.keys(ATTR_MAP);
